import { DropdownField as FieldDefinition } from '@bybeam/platform-types';
import Dropdown from '@platform-ui-common/components/Dropdown/index.js';
import { DropdownProps } from '@platform-ui-common/components/Dropdown/types.js';
import {
  GenericFormData,
  fieldUpdate,
  updateRepeated,
} from '@platform-ui-common/hooks/useForm/index.js';
import { FieldProps } from './types.js';

export default function DropdownField<FormData extends GenericFormData>({
  answers,
  dispatch,
  errors,
  field: { key, copy, options, props },
  labelPrefix,
  repeated,
  showManualAddressButton: _,
  showManualInput: __,
  setValidationOverrides: ___,
  validation,
  ...rest
}: FieldProps<FieldDefinition, FormData>): JSX.Element {
  const label = labelPrefix ? `${labelPrefix} ${copy}` : copy;
  const dropdownProps = {
    id: key,
    label,
    value: answers[key] ?? '',
    items: options,
    onChange: (value): void =>
      repeated
        ? dispatch(updateRepeated(repeated.parentKey, repeated.index, key, value))
        : dispatch(fieldUpdate(key, value as FormData[typeof key])),
    required: validation?.required,
    error: errors[key] as string,
    ...props,
    ...rest,
  } as DropdownProps;
  return (
    <div className="flex flex-col lg:max-w-[36rem]">
      <Dropdown {...dropdownProps} />
    </div>
  );
}
